import { Suspense } from "react";
import { Outlet } from "react-router-dom";

import { AuthInit } from "./modules/auth";
import { MasterInit } from "../_metronic/layout/MasterInit";
import { I18nProvider } from "../_metronic/i18n/i18nProvider";
import { LayoutProvider, LayoutSplashScreen } from "../_metronic/layout/core";

import { AttendanceIdContextProvider } from "./contexts/AttendanceIdContext";
import { AttendanceContextProvider } from "./contexts/AttendanceContext";
import { PatientContextProvider } from "./contexts/PatientContext";

const App = () => {
	return (
		<Suspense fallback={<LayoutSplashScreen />}>
			<I18nProvider>
				<LayoutProvider>
					<AuthInit>
						<PatientContextProvider>
							<AttendanceIdContextProvider>
								<AttendanceContextProvider>
									<Outlet />
									<MasterInit />
								</AttendanceContextProvider>
							</AttendanceIdContextProvider>
						</PatientContextProvider>
					</AuthInit>
				</LayoutProvider>
			</I18nProvider>
		</Suspense>
	);
};

export { App };
